import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        highSchool: [],
        primarySchool: []
    },
    mutations: {
        setHighSchool(state, highSchool) {
            state.highSchool = highSchool;
        },
        setPrimarySchool(state, primarySchool) {
            state.primarySchool = primarySchool;
        }
    },
    mounted() {
        this.$store.dispatch('getClasses')
    },
    actions: {
        getGrades({ commit }) {
            skoleApi.get("razredi").then(response => {
                if (response.status === 200) {
                    commit('setHighSchool', response.data[1]);
                    commit('setPrimarySchool', response.data[0]);
                }
            })

        }
    },
    getters: {
        getHighSchoolId(state) {
            return grade => {
                let item = state.highSchool.find(item => {
                    return item.grade == grade;
                });
                if (item)
                    return item.id;
                return null;
            }
        },
        getPrimarySchoolId (state) {
            return grade => {
                let item = state.primarySchool.find(item => {
                    return item.grade == grade;
                });
                if (item)
                    return item.id;
                return null;
            }
        }
    }
})